<template lang="pug">
el-table(:data="devices" cell-class-name="el-table-cell" row-class-name="el-table-row" v-loading="loading")
  .empty(slot="empty")
    img(:src="images.device_empty")
    p(v-html="nl2br($t('Cuona.Device.description02'))")
    template(v-if="edit==true")
      el-button(type="info" size="mini" @click="$emit('openDialog')") {{ $t('Cuona.Device.set_device') }}
  el-table-column(prop="name" :label="$t('Cuona.Device.name')" sortable="")
    template(slot-scope="props")
      img.device-image(:src="getCuonaImage(props.row)")
      i.el-icon-warning(v-if="props.row.status == 'dirty'")
      span {{ props.row.name }} 
  el-table-column(prop="nfc_uid" width="180px" :label="$t('Cuona.Device.id')" sortable="")
  el-table-column(prop="events" :label="$t('Cuona.Device.events')" sortable="")
    template(slot-scope="props")
      template(v-for="event in props.row.events")
        el-tag.tag(size="mini" type="success") {{ event.name }}
  el-table-column(prop="groups" :label="$t('Cuona.Device.group_name')" sortable="")
    template(slot-scope="props")
      template(v-for="group in props.row.groups")
        el-tag.tag(size="mini") {{ group.name }}
  el-table-column(width="100px" align="center")
    template(slot-scope="props")
      router-link(:to="{name:'device', params:{id: trimDeviceId(props.row.nfc_uid)}}")
        i.setting.el-icon-setting
        | {{ $t('Cuona.Device.detail') }}
</template>

<script>
export default {
  data () {
    return {
      images: {
        cube: require('@/assets/cuona_cube.svg'),
        seal: require('@/assets/cuona_seal.svg'),
        device_empty: require('@/assets/device_empty.svg')
      }
    }
  },
  props: {
    devices: Array,
    edit: Boolean,
    loading: {
      type: Boolean,
      default: true
    }
  },
  methods: {

    // CUONAのアイコンを設定
    getCuonaImage: function(device) {
      return (device.device_type != 'cube') ? this.images.seal : this.images.cube
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";
@import "../../styles/table-layout.scss";

</style>
